import useBuyStore from "../store/BuyStore";

const TbDirectDebitMapper = {
  get() {
    const buyStore = useBuyStore.getState();
    const directDebitDetails = buyStore.getObject("directDebitDetails");

    return {
      sortCode: directDebitDetails?.sortCode ?? "",
      sortCodeFormatted: directDebitDetails?.sortCodeFormatted ?? "",
      AccountNo: directDebitDetails?.accountNumber ?? "",
      docTermsAccepted: directDebitDetails?.isAccountHolder ?? false,
    };
  },

  set(data) {
    const buyStore = useBuyStore.getState();
    buyStore.setObject("directDebitDetails", {
      sortCode: data.sortCode,
      sortCodeFormatted: data.sortCodeFormatted,
      accountNumber: data.AccountNo,
      isAccountHolder: true,
    });
  },

  formatSortCode(value) {
    const cleanValue = value.replace(/[^0-9]/g, "");
    if (cleanValue.length > 6) return cleanValue.substring(0, 6);
    return cleanValue.match(/.{1,2}/g)?.join("-") || "";
  },
};

export default TbDirectDebitMapper;
